module.exports = __webpack_public_path__ + "images/Box.9891e2c968774043af868505ebac9e2b.svg";